<template>
    <span class="dropdown" v-bind="$attrs">
        <span class="rc__preview__text cursor-pointer text--underline text--medium" data-bs-toggle="dropdown" aria-expanded="false">
            [{{ modelValue ? modelValue : placeholder }}]
        </span>
        
        <div class="dropdown-menu pt--0 pb--0 email--dropdown--menu">
            <form>
                <div>
                    <div class="w-100">
                        <div>
                            <input 
                                v-bind="{...$attrs }" 
                                ref="inputElement"
                                type="text"
                                class="w-100 form-control form__input form__input__border__none"
                                :class="
                                    {
                                        'form__input-error': isError,
                                        [`form-control-${size}`]: size,
                                    }"
                                :value="modelValue"
                                placeholder="Enter alternative text here..."
                                autocomplete=""
                                @input="e => $emit('update:modelValue', e.target.value)"
                                @change="e => $emit('change', e)"
                                @keydown="e => $emit('keydown', e)"
                                @keyup="$emit('keyup', event)"
                            >
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </span>
</template>

<script>
export default {
    name: "EmailTextSelect",

    props: {
        modelValue: { default: "", type: [Number, String] },
        placeholder: {
            type: String,
            default: "",
        },
        loading: { type: Boolean, default: false },
        disabled: { type: Boolean, default: false },
        id: {
            type: String,
            default: "",
        },
        required: {
            type: Boolean,
            default: undefined,
        },
        isError: {
            type: Boolean,
            default: false,
        },
        errMsg: {
            type: String,
            default: "",
        },
        size: {
            type: String,
            default: "xs",
            validator: (value) => {
                return ["xs", "sm", "md", "lg"].includes(value);
            },
        },
    },

    emits: ["input", "blur", "change", "keydown", "focus", "keyup", "update:modelValue"],

    data() {
        return {
            inputValue: "", 
        };
    },

    mounted() {       
        setTimeout(() => {
            this.$refs.inputElement?.focus();
        }, 200);
    },

    methods: {
        addValue() {
            this.$emit("update-email-text", this.modelValue);
        },

        removeValue() {
            this.$emit("update-email-text", "");
        },
    },
};
</script>

<style lang="scss" scoped>
.email--dropdown--menu {
    min-width: 14rem;
}
</style>